module.exports = __webpack_public_path__ + "static/fleet-49-seat-coach-sm-04af3053d09d84d0544149b96912fc39.webp";